<template>
  <div class="dashboard__view">
    <div class="page">
      <div class="relative">
        <div class="text-light">
          <p>
            Filter Payouts :
            <span @click="openFilters = !openFilters"
            >All Payouts
              <svg
                      width="10"
                      height="6"
                      viewBox="0 0 10 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      :class="openFilters ? '' : 'rotate'"
              >
                <path
                        d="M1 1L5 5L9 1"
                        stroke="#e00b5b"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                />
              </svg>
            </span>
          </p>
        </div>
        <div class="filter-dropdown" v-if="openFilters">
          <div class="filter-title">Payouts</div>
          <div class="form__item">
            <input
                    class="form__input"
                    type="text"
                    v-model="filterList.merchantId"
                    placeholder="Merchant"
            />
          </div>
          <div class="form__item"  v-if="$route.name.toLowerCase() !== 'view-payout-dashboard-funding'">
            <input
                    class="form__input"
                    type="text"
                    v-model="filterList.balance"
                    placeholder="Amount"
            />
          </div>

          <div class="form__item"  v-if="$route.name.toLowerCase() === 'view-payout-dashboard-funding'">
            <input
                    class="form__input"
                    type="date"
                    v-model="filterList.transaction_date"
                    placeholder="Payment Date"
            />
          </div>

          <div class="form__item"  v-if="$route.name.toLowerCase() === 'view-payout-dashboard-funding'">
            <input
                    class="form__input"
                    type="text"
                    v-model="filterList.reference"
                    placeholder="Payment Reference"
            />
          </div>
          <div class="">
            <p class="filter-title">STATUS</p>
            <div
                    v-for="status in statusGroup"
                    class="status-element"
                    :key="status.id"
                    @click="() => (filterList.status = status.id)"
            >
              <p v-if="status.id === filterList.status">
                <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="8" fill="#e00b5b" />
                  <path
                          d="M11 6L6.875 10L5 8.18182"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                  />
                </svg>
              </p>
              <p v-else>
                <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="7.5" stroke="#979797" />
                </svg>
              </p>
              <p class="filter-title">{{ status.name }}</p>
            </div>
          </div>
          <div class="button-group">
            <button
                    class="btn woven-border-only woven-red"
                    @click="clearFilter"
                    style="margin-right: 5px;"
            >
              Reset Filter
            </button>
            <button class="btn woven-color" @click="triggerFilter">
              <p>Filter</p>
            </button>
          </div>
        </div>
      </div>
      <br />
    </div>

    <div class="list">
      <div class="tab__content">
        <div class="tab__content__top">
          <Tab :tabs="tabs" />
        </div>

        <EmptyState v-if="emptyState" type="not-found" />
        <div v-else>
          <!-- Loader -->

          <table class="table card-table larger-td" v-if="transactionList && !loading">
            <thead>
            <tr v-if="$route.name.toLowerCase() === 'view-payout-dashboard'">
              <th></th>
              <th>MERCHANT</th>
              <th>AMOUNT</th>
              <th>BENEFICIARY</th>
              <th>BENEFICIARY</th>
              <th style="text-align: left;">TRANSACTION TIME</th>
            </tr>

            <tr v-else-if="$route.name.toLowerCase() === 'view-payout-dashboard-funding'">
              <th></th>
              <th>MERCHANT</th>
              <th>AMOUNT</th>
              <th>OPENING BALANCE</th>
              <th>CLOSING BALANCE</th>
              <th>PAYMENT DATE</th>
              <th style="text-align: left;">PAYMENT REFERENCE</th>
            </tr>

            <tr v-else>
              <th>MERCHANT</th>
              <th>ACCOUNT</th>
              <th>BALANCE</th>
              <th style="text-align: left;">TRANSACTION TIME</th>
            </tr>

            </thead>
            <tbody  v-if="$route.name.toLowerCase() === 'view-payout-dashboard'"
            >
            <tr
                    :key="item.unique_reference"
                    @click="gotoPayout(item)"
                    v-for="item in transactionList"
            >
              <td style="max-width: 20px">
                <StatusIndicator :type="item.transaction_status" />
              </td>
              <td>
                {{ item.merchant_name }} <br />
                <span style="font-size: 12px;line-height: 20px;color: rgba(38, 25, 64, 0.6);">{{ item.account_email || 'N/A'}}</span>
              </td>
              <td>₦{{ item.amount }}</td>
              <td>{{ item.beneficiary_account_name }}</td>
              <td>

                {{
                bankNames[item.bank_code]
                ? bankNames[item.bank_code].name
                : ""
                }}
                <br />
                <span style="font-size: 12px;line-height: 20px;color: rgba(38, 25, 64, 0.6);">{{ item.beneficiary_nuban }}</span>
              </td>
              <td  style="text-align: left;">
                {{ moment(item.transaction_date).format("ddd, MMMM D YYYY") }}
                <br />
                <span style="font-size: 12px;line-height: 20px;color: rgba(38, 25, 64, 0.6);">
                   {{ moment(item.transaction_date).format(" h:mm a") }}
                </span>
              </td>

            </tr>
            </tbody>

            <tbody  v-else-if="$route.name.toLowerCase() === 'view-payout-dashboard-funding'"
            >
            <tr
                    :key="item.unique_reference"
                    @click="gotoTransaction(item)"
                    v-for="item in transactionList"
            >
              <td style="max-width: 20px">
                <StatusIndicator :type="item.transaction_status" />
              </td>
              <td>{{ item.merchant_name || 'Not Available' }}</td>
              <td>₦{{ formatAmount(item.amount || 0) }}</td>
              <td>₦{{ formatAmount(item.opening_balance || 0) }}</td>
              <td>₦{{ formatAmount(item.closing_balance || 0) }}</td>

              <td  style="text-align: left;">
                {{ moment(item.transaction_date).format("ddd, MMMM D YYYY") }}
                <br />
                <span style="font-size: 12px;line-height: 20px;color: rgba(38, 25, 64, 0.6);">
                   {{ moment(item.transaction_date).format(" h:mm a") }}
                </span>
              </td>
              <td  style="text-align: left;">{{ item.reference }}</td>

            </tr>
            </tbody>

            <tbody v-else>

            <tr
                :key="item.unique_reference"
                @click="gotoAccountReserve(item)"
                v-for="item in transactionList">

              <td>{{ item.merchant }}</td>
              <td>{{ item.account_name }}</td>
              <td>₦{{ formatAmount(item.balance) }}</td>

              <td style="text-align: left;">
                {{ moment(item.created_at).format("ddd, MMMM D YYYY") }}
                <br />
                <span style="font-size: 12px;line-height: 20px;color: rgba(38, 25, 64, 0.6);">
                   {{ moment(item.created_at).format(" h:mm a") }}
                </span>
              </td>
            </tr>
            </tbody>
          </table>

          <div class="loader" v-else>
            <span aria-hidden="true" class="spinner-border"></span>
          </div>

          <div
                  class="table__details"
                  v-if="transactionList && !loading && !emptyState"
          >
            <div class="table__details__left">
              <span class="text-muted" v-if="pageInfo.total"
              >Page {{ pageInfo.current_page }} of
                {{ pageInfo.total_pages }}</span
              >
            </div>
            <div class="table__details__right">
              <Pagination :numberOfPages="pageInfo.total_pages" />
            </div>
            <div class="table__details__right"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Datepicker from "vuejs-datepicker";
  import emptyTransactions from "../../../components/emptytransactions";
  import Inputv2Search from "../../../components/inputv2-search";
  import Pagination from "@/components/pagination.vue";
  import InputV2 from "../../../components/inputv2";
  import ButtonV2 from "../../../components/buttonV2";
  import Modal from "../../../components/modal";
  import WovenStrip from "../../../components/wovenstrip";
  import Textarea from "../../../components/textarea";
  import Dropdown from "@/components/dropdown";
  import StatusIndicator from "@/components/status-indicator.vue";
  import Tab from "@/components/tab.vue"
  import { formatAmount } from "@/lib/formatAmount.js"
  import EmptyState from "@/components/empty-state.vue";

  export default {
    metaInfo: {
      title: "Transactions",
    },
    created() {
      this.fetchTransactions();
    },

    components: {
      Datepicker,
      emptyTransactions,
      Inputv2Search,
      InputV2,
      ButtonV2,
      Modal,
      WovenStrip,
      Textarea,
      Dropdown,
      Pagination,
      StatusIndicator, Tab,EmptyState
    },

    data() {
      return {
        tabs: [
          {
            url: `/dashboard/payouts`,
            name: "Recent Payouts",
          },
          // {
          //   url: `/dashboard/payout/summaries`,
          //   name: "Account  Summaries",
          // },
          {
            url: `/dashboard/payout/funding`,
            name: "Funding History",
          },
        ],
        specificTransaction: {},
        specificAudit: [],
        showFilterDateInput: false,
        transactionList: "",
        pageInfo: "",
        filterList: {
          balance: this.$route.query.balance
              ? this.$route.query.balance
              : "",
          reference: this.$route.query.unique_reference
                  ? this.$route.query.unique_reference
                  : "",
          vnuban: this.$route.query.nuban ? this.$route.query.nuban : "",
          status: this.$route.query.status ? this.$route.query.status : "",
          to: this.$route.query.to ? this.$route.query.to : "",
          from: this.$route.query.from ? this.$route.query.from : "",
        },
        disabled: false,
        polling: "",
        exportDisabled: false,
        loading: true,
        emptyState: false,
        openFilters: false,
        showModal: false,
        styleClass: "",
        statusGroup: [
          {
            id: "Active",
            name: "Successful",
          },
          {
            id: "Failed",
            name: "Failed",
          },
          {
            id: "Pending",
            name: "INQ",
          },
        ],
      };
    },

    methods: {
      formatAmount: formatAmount,
      moment: window.moment,
      gotoPayout(item) {
        this.$router.push({
          name: "view-payout-single-details",
          params: { id: item.merchant_id, reference: item.unique_reference },
        });
      },

      gotoTransaction(item) {
        this.$router.push({
          name: "transaction-details",
          params: { id: item.reference },
        });
      },
      gotoAccountReserve(item) {
        this.$router.push({
          name: "view-accounts",
          params: { id: item.merchant_id, reference: item.payout_reference },
        });
      },
      toggleShowDateFilter() {
        this.showFilterDateInput = !this.showFilterDateInput;
      },
      toggleFilters() {
        this.openFilters = !this.openFilters;
      },
      returnQuery() {
        let queryParams = Object.entries(this.$route.query);
        let generatedQuery = "";
        let i = 0;
        // Loop through arrays and generate the query string
        for (let [name, value] of queryParams) {
          generatedQuery += `${name}=${value}`;
          i++;
          if (i < queryParams.length) {
            generatedQuery += "&";
          }
        }
        return generatedQuery;
      },
      generatePaginationLink(pageNum) {
        return {
          path: "/dashboard/transactions",
          query: {
            ...this.$route.query,
            page: pageNum,
          },
        };
      },

      triggerFilter() {
        let queryObject = {};
        if (this.filterList.reference !== "") {
          queryObject.reference = this.filterList.reference.trim();
        }
        if (this.filterList.merchantId) {
          queryObject.merchant = this.filterList.merchantId.trim();
        }
        if (this.filterList.reference) {
          queryObject.reference = this.filterList.reference.trim();
        }
        if (this.filterList.vnuban) {
          queryObject.vnuban = this.filterList.vnuban.trim();
        }
        if (this.filterList.status) {
          queryObject.status = this.filterList.status;
        }
        if (this.filterList.to !== "") {
          queryObject.to = moment(this.filterList.to).format(
                  "YYYY-MM-DD 23:59:59"
          );
        }

        if (this.filterList.transaction_date) {
          queryObject.from = moment(this.filterList.transaction_date).format(
                  "YYYY-MM-DD 00:00:00"
          );
        }
        if (this.filterList.from !== "") {
          queryObject.from = moment(this.filterList.from).format(
                  "YYYY-MM-DD 00:00:00"
          );
        }
        if (this.filterList.balance) {
          queryObject.amount = this.filterList.balance;
        }
        if (this.$route.query.merchantId) {
          queryObject.merchantId = this.$route.query.merchantId;
        }
        if (this.$route.query.bankCode) {
          queryObject.bankCode = this.$route.query.bankCode;
        }

        queryObject.page = 1;
        //Route to page with query
        this.$router.push({
          name: this.$route.name,
          query: queryObject,
        });
        this.openFilters = false;
      },
      clearFilter() {
        this.filterList = {
          reference: "",
          vnuban: "",
          status: "",
          to: "",
          from: "",
        };
        this.openFilters = false;
        this.$router.go();
      },
      fetchTransactions() {
        this.transactionList = null;
        // Convert object to multiple arrays with name and value
        let generatedQuery = this.returnQuery();
        let appendedQuery = "";
        // check for mode to append query
        if (!this.mode) {
          appendedQuery = "&ignore_admin_flag=1";
        } else {
          appendedQuery = "&ignore_admin_flag=1&is_test=1";
        }

        let url = `dashboard/admin/payouts/list?`
        if (this.$route.name.toLowerCase() === 'view-payout-dashboard-summaries') {
          url = 'dashboard/merchant/payouts/summary?'
        }
        if (this.$route.name.toLowerCase() === 'view-payout-dashboard-funding') {
          url = 'dashboard/admin/account/history?'
        }
        this.$http
                .get(url + generatedQuery + appendedQuery)
                .then((response) => {
                  if (response.body.data.payout_transactions && response.body.data.payout_transactions.length > 0) {
                    this.transactionList = response.body.data.payout_transactions;
                    this.pageInfo = response.body.data.page_info;
                    this.emptyState = false;
                  } else  if (response.body.data.payout_summaries && response.body.data.payout_summaries.length > 0) {
                    this.transactionList = response.body.data.payout_summaries;
                    this.pageInfo = response.body.data.page_info;
                    this.emptyState = false;
                  }  else  if (response.body.data.funding_history && response.body.data.funding_history.length > 0) {
                    this.transactionList = response.body.data.funding_history;
                    this.pageInfo = response.body.data.page_info;
                    this.emptyState = false;
                  } else {
                    this.emptyState = true;
                  }
                  this.loading = false;
                })
                .catch((error) => {
                  // LOG Error
                });
        this.openFilters = false;
      },

      exportData() {
        this.exportDisabled = true;
        let generatedQuery = this.returnQuery();
        let url = process.env.VUE_APP_API_URL;
        const token = this.userDetails.token;
        url = `${url}/admin/transactions?download=1&${generatedQuery}&token=${token}`;
        window.open(url);
        setTimeout(() => {
          this.exportDisabled = false;
          this.$notify({
            group: "notifications-default",
            type: "success text-white",
            title: "Success",
            text: "Exporting in progress please wait..",
          });
        }, 3000);
      },
      pollDownload(identifier) {
        this.$http.get(`dashboard/downloads/${identifier}`).then((response) => {
          // if data is available stop polling
          this.exportDisabled = false;
          clearInterval(this.polling);
          window.location.assign(response.body.data.file_url);
        });
      },
    },

    computed: {
      mode() {
        return this.$store.state.userDetails.is_test;
      },
      bankNames() {
        return this.$store.state.bankNames;
      },
      userDetails() {
        return this.$store.state.userDetails;
      },
    },

    watch: {
      // call again the fetch method if the route changes; this is necessary especially because of users
      // using the search and might be on this route already.
      $route: "fetchTransactions",
    },
  };
</script>

<style lang="scss" scoped>
  // filter styles start
  .relative {
    position: relative;
  }

  .rotate {
    transform: rotate(180deg);
  }

  .woven-color {
    background: #e00b5b;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    height: 40px;

    svg {
      margin-right: 5px;
    }

    .btn--text {
      font-style: normal;
      font-weight: 500;
      color: #fff;
      width: 100%;
      text-align: center;
    }
  }

  .woven-border-only {
    background: #fff;
    border: 1px solid #e00b5b;
    height: 40px;

    svg {
      margin-left: 5px;
    }

    .btn--text {
      font-style: normal;
      font-weight: 500;
      text-align: center;
      color: #e00b5b;
    }
  }

  .filter-dropdown {
    background: #fff;
    padding: 20px;
    background: #ffffff;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
    position: absolute;
    top: 30px;
    left: 145px;

    .form__item {
      margin-bottom: 16px;
    }
  }

  .woven-red {
    color: #e00b5b;
  }

  .button-group {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    margin-top: 32px;
    border-top: 1px solid rgba(196, 196, 196, 0.5);

    p {
      width: 100%;
    }

    .btn {
      width: 100px;
      height: 40px;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      padding: 10px;
      text-align: center;
    }
  }

  .date-group {
    display: flex;
  }

  .margin-right {
    margin-right: 16px;
  }

  .date {
    border: 0.5px solid rgba(97, 110, 124, 0.5);
    box-sizing: border-box;
    border-radius: 4px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: rgba(97, 110, 124, 0.8);
    padding: 12px 10px;
    max-width: 112px;
  }

  .status-element {
    display: flex;

    svg {
      margin-right: 10px;
      cursor: pointer;
    }
  }

  .text-light {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #595959;

    span {
      color: #e00b5b;
      cursor: pointer;
    }
  }

  .filter-title {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 14px;
    color: #9a9fa3;
    margin-bottom: 16px;
  }

  // filter styles end

  .empty__text {
    &__caption {
      max-width: 300px;
      line-height: 24px;
    }
  }
  .toggle-date {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;

    color: #595959;
    text-transform: capitalize !important;
    display: flex;
    .date {
      margin: 0 20px;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 24px;
      /* identical to box height, or 150% */

      color: #e00b5b;
      cursor: pointer;
    }
  }
  .btn-filter {
    height: 50px;

    border: 1px solid #fd8387;
    box-sizing: border-box;
    border-radius: 4px;
    background: transparent !important;
  }
</style>

<style lang="scss" scoped>
  .empty__text {
    &__caption {
      max-width: 300px;
      line-height: 24px;
    }
  }
  .toggle-date {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;

    color: #595959;
    text-transform: capitalize !important;
    display: flex;
    .date {
      margin: 0 20px;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 24px;
      /* identical to box height, or 150% */

      color: #e00b5b;
      cursor: pointer;
    }
  }
  .btn-filter {
    height: 50px;
    border: 1px solid #fd8387;
    box-sizing: border-box;
    border-radius: 4px;
    background: transparent !important;
  }
  .no-bg {
    background: none !important;
  }
  .larger-td {
    font-family: Lato !important;
    td {
      font-size: 14px !important;
      line-height: 20px;
      color: #261940 !important;
    }
    th {
      font-weight: bold !important;
      line-height: 14px !important;
      letter-spacing: 0.1em !important;
      text-transform: uppercase !important;
      color: rgba(89, 89, 89, 0.6) !important;
    }
  }
</style>
<style lang="scss">
  .tag.no-bg {
    padding: 0 !important;
  }
  .sudo-transactions-details {
    max-width: 520px;
    max-height: 80vh;
    width: 100% !important;
    height: 80vh;
    padding: 0;
    .modal {
      height: 80vh;
      padding: 0;
      display: block !important;
    }
    .drop-down {
      width: 100%;
    }

    .left {
      max-width: 55%;
      flex: 1;
      padding: 10px;
      overflow: auto;
    }
    .right {
      max-width: 45%;
      width: 400px;
      flex: 0.5;
      background: #f5f5f7;
      border-radius: 6px;
      text-align: left;
      padding: 10px;
      margin: 40px;

      .audit-title {
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 22px;
        padding: 10px 15px;

        color: #000000;
      }
      .audit-box {
        padding: 15px;
        border-bottom: 1px solid #ebf0f4;
      }
      .audit-type {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: rgba(0, 0, 0, 0.7);
      }
      .audit-date {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 20px;
        color: rgba(38, 25, 64, 0.6);
      }
    }
    &.modal-content,
    &__content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      background: #ffffff !important;
      border-radius: 10px 10px 0px 0px;
      max-width: 90%;
      width: 100% !important;
      height: 100%;
      margin: auto;
      text-align: center;
      padding: 15px 0;

      &__transaction_item {
        display: flex;
        justify-content: space-between;
        width: 100%;
        border-bottom: 1px solid #ebf0f4;
        padding: 20px 0;

        &__top {
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
          color: rgba(0, 0, 0, 0.5);
          padding: 10px 0;
        }
        &__info {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 18px;
          color: #261940;
        }
      }
    }
    &__title {
      font-style: normal;
      font-weight: 500;
      font-size: 24px;
      line-height: 36px;
      text-align: left;
      color: #000000;
    }
  }
</style>
